#import "./EventCancelItemFields.graphql"

fragment EventCancelProgressFields on EventCancelProgress {
  startedAt
  finishedAt
  message
  total
  refunded
  manual
  free
  disputed
  failed
  pending
  failures {
    ...EventCancelItemFields
  }
  manualItems {
    ...EventCancelItemFields
  }
}
